import { CalendarClock } from "lucide-react";

export const daysLeft = (d) => {
  if (!d) return null;
  const [y, m, day] = d.split("-").map(Number);
  const t = new Date(); t.setHours(0, 0, 0, 0);
  return Math.round((new Date(y, m - 1, day) - t) / 86400000);
};

export const DeadlineBadge = ({ date, testId }) => {
  const n = daysLeft(date);
  if (n === null || n > 7) return null;
  const red = n <= 0;
  const label = n < 0 ? `Loan deadline passed ${-n}d ago` : n === 0 ? "Loan deadline today" : `Loan deadline in ${n}d`;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded-full ${red ? "bg-rose-500/15 text-rose-300" : "bg-amber-500/15 text-amber-300"}`}>
      <CalendarClock className="h-3 w-3" />{label}
    </span>
  );
};
